import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export function NotFoundPage() {
  return (
    <section className="stack-md">
      <Seo title="타로맨스 | 페이지 없음" description="요청하신 페이지를 찾을 수 없습니다." />
      <h1>페이지를 찾을 수 없습니다.</h1>
      <Link className="btn" to="/">홈으로 이동</Link>
    </section>
  );
}
